<p class="c1 col-12"
   *iCms="'text' of content; skipEmpty: true"
   text>
</p>